(() => {
  const CAMPAIGN = {
    endAt: '2026-08-01T06:59:59Z',
    eligibleVendors: ['Spongellé'],
    eligibleTags: ['Spongelle', 'Partner Product'],
    giftMarker: 'july-2026-launch',
    offerType: 'Partner product gift',
    giftImage: 'https://cdn.shopify.com/s/files/1/0548/5721/files/Brass_Ring-1080x1080-03_269399b6-afaa-4b0e-9dc7-5de9f6e631ee.png?v=1762461082',
    variants: [
      { size: '5', id: 39693750796366 },
      { size: '6', id: 39693750763598 },
      { size: '7', id: 39693750730830 },
      { size: '8', id: 39693750698062 },
      { size: '9', id: 39693750665294 },
      { size: '10', id: 39693750632526 }
    ]
  };

  if (window.__spongelleRingGiftLoaded || Date.now() > Date.parse(CAMPAIGN.endAt)) return;
  window.__spongelleRingGiftLoaded = true;

  const state = {
    selectedSize: localStorage.getItem('spongelle-ring-size') || '',
    submitting: false,
    modalOpen: false
  };

  const rootRoute = window.Shopify?.routes?.root || '/';
  const route = path => `${rootRoute}${path}`.replace(/\/+/g, '/');
  const routes = {
    add: route('cart/add.js'),
    change: route('cart/change.js'),
    update: route('cart/update.js')
  };

  const normalize = value => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

  const escapeHtml = value => String(value).replace(/[&<>"']/g, character => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const isEligibleProduct = product => {
    if (!product) return false;
    const vendorMatch = CAMPAIGN.eligibleVendors.some(vendor => normalize(product.vendor) === normalize(vendor));
    const tags = Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || '').split(',').map(tag => tag.trim());
    const tagMatch = tags.some(tag => CAMPAIGN.eligibleTags.some(eligibleTag => (
      normalize(tag) === normalize(eligibleTag)
    )));
    return vendorMatch || tagMatch;
  };

  const variantForSize = size => CAMPAIGN.variants.find(variant => variant.size === String(size));

  const sizeButtons = (name, selected = '') => CAMPAIGN.variants.map(variant => `
    <label class="srg-size">
      <input type="radio" name="${escapeHtml(name)}" value="${variant.size}" ${variant.size === String(selected) ? 'checked' : ''}>
      <span>${variant.size}</span>
    </label>
  `).join('');

  const productWidgetMarkup = () => `
    <section class="srg-card" data-srg-pdp aria-labelledby="srg-pdp-title">
      <div class="srg-card__gift">
        <img src="${CAMPAIGN.giftImage}" alt="" width="88" height="88" loading="lazy">
        <span class="srg-card__badge">FREE</span>
      </div>
      <div class="srg-card__content">
        <p class="srg-eyebrow">LAUNCH GIFT · THROUGH JULY 31</p>
        <h3 id="srg-pdp-title">Choose your free Mystery Ring</h3>
        <p>Save your preferred size, then confirm all your free gifts together in the cart.</p>
        <fieldset class="srg-fieldset">
          <legend>Ring size</legend>
          <div class="srg-sizes">${sizeButtons('spongelle-ring-pdp', state.selectedSize)}</div>
        </fieldset>
        <p class="srg-selection-note" data-srg-selection-note>
          ${state.selectedSize ? `Size ${escapeHtml(state.selectedSize)} selected` : 'You can also choose your size in the cart.'}
        </p>
        <p class="srg-fine-print">One free ring per eligible partner product, while supplies last. Partner products are excluded from other product and order discounts.</p>
      </div>
    </section>
  `;

  const installProductWidget = async () => {
    if (window._template?.name !== 'product') return;

    let product;
    try {
      const response = await fetch(`${window.location.pathname}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      product = await response.json();
    } catch (_) {
      return;
    }

    if (!isEligibleProduct(product)) return;

    const paymentContainer = document.querySelector('product-payment-container');
    const form = paymentContainer?.getAttribute('form-id')
      ? document.getElementById(paymentContainer.getAttribute('form-id'))
      : document.querySelector('form[action*="/cart/add"]');
    const anchor = paymentContainer || form;
    if (!form || !anchor || document.querySelector('[data-srg-pdp]')) return;

    anchor.insertAdjacentHTML('beforebegin', productWidgetMarkup());
    document.querySelector('[data-srg-pdp]')?.addEventListener('change', event => {
      if (event.target.name !== 'spongelle-ring-pdp') return;
      state.selectedSize = event.target.value;
      localStorage.setItem('spongelle-ring-size', state.selectedSize);
      const note = document.querySelector('[data-srg-selection-note]');
      if (note) note.textContent = `Size ${state.selectedSize} selected`;
    });
  };

  const readCartSelection = prompt => {
    const cartRoot = prompt.closest('cart-drawer, .cart') || document;
    const giftLines = [...cartRoot.querySelectorAll('[data-srg-gift-line]')].map(line => ({
      key: line.dataset.srgLineKey || '',
      size: line.dataset.srgRingSize || '',
      quantity: Math.max(0, Number.parseInt(line.dataset.srgQuantity || '0', 10) || 0)
    })).filter(line => line.key && line.quantity);
    const giftSizes = giftLines.flatMap(line => Array.from({ length: line.quantity }, () => line.size));

    return {
      eligible: Math.max(0, Number.parseInt(prompt.dataset.eligible || '0', 10) || 0),
      giftLines,
      giftSizes
    };
  };

  const modalMarkup = selection => {
    const selectionCount = selection.eligible;
    const selectedSizes = Array.from({ length: selectionCount }, (_, index) => (
      selection.giftSizes[index] || state.selectedSize || ''
    ));

    return `
      <dialog class="srg-modal" data-srg-modal aria-labelledby="srg-modal-title">
        <div class="srg-modal__panel">
          <button class="srg-modal__close" type="button" data-srg-close aria-label="Close">&times;</button>
          <div class="srg-modal__header">
            <img src="${CAMPAIGN.giftImage}" alt="" width="96" height="96">
            <div>
              <p class="srg-eyebrow">YOUR COMPLIMENTARY GIFT</p>
              <h2 id="srg-modal-title">Choose ${selectionCount === 1 ? 'your ring size' : 'your ring sizes'}</h2>
              <p>${selectionCount === 1 ? 'Select one size for your free Mystery Ring.' : `Choose each of your ${selectionCount} free Mystery Rings separately.`}</p>
            </div>
          </div>
          <div class="srg-modal__choices">
            ${selectedSizes.map((selectedSize, index) => `
              <fieldset class="srg-fieldset srg-fieldset--modal">
                <legend>${selectionCount === 1 ? 'Ring size' : `Ring ${index + 1} size`}</legend>
                <div class="srg-sizes">${sizeButtons(`spongelle-ring-modal-${index}`, selectedSize)}</div>
              </fieldset>
            `).join('')}
          </div>
          <p class="srg-error" data-srg-modal-error role="alert" hidden></p>
          <button class="button button--primary button--full srg-modal__add" type="button" data-srg-modal-add>
            Update free ${selectionCount === 1 ? 'ring' : 'rings'}
          </button>
          <p class="srg-fine-print">The free price is applied automatically. One per eligible partner product, while supplies last.</p>
        </div>
      </dialog>
    `;
  };

  const closeModal = () => {
    const modal = document.querySelector('[data-srg-modal]');
    if (modal?.open) modal.close();
    modal?.remove();
    document.body.classList.remove('srg-modal-open');
    state.modalOpen = false;
  };

  const openModal = prompt => {
    const selection = readCartSelection(prompt);
    if (!selection.eligible || state.modalOpen) return;

    document.querySelector('[data-srg-modal]')?.remove();
    document.body.insertAdjacentHTML('beforeend', modalMarkup(selection));
    const modal = document.querySelector('[data-srg-modal]');
    if (!modal) return;

    modal._srgSelection = selection;
    modal.addEventListener('cancel', event => {
      event.preventDefault();
      closeModal();
    });
    modal.addEventListener('click', event => {
      if (event.target === modal) closeModal();
    });
    modal.showModal();
    document.body.classList.add('srg-modal-open');
    state.modalOpen = true;
    modal.querySelector('input:not(:checked), input')?.focus();
  };

  const showModalError = message => {
    const error = document.querySelector('[data-srg-modal-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  };

  const giftProperties = (size, selectionToken) => ({
    _spongelle_gift: CAMPAIGN.giftMarker,
    '_Offer type': CAMPAIGN.offerType,
    '_Ring size': String(size),
    '_Gift selection': selectionToken
  });

  const sizesMatch = (first, second) => {
    if (first.length !== second.length) return false;
    const sortedFirst = [...first].sort();
    const sortedSecond = [...second].sort();
    return sortedFirst.every((size, index) => size === sortedSecond[index]);
  };

  const groupedGiftItems = (sizes, selectionToken) => {
    const quantities = sizes.reduce((result, size) => {
      result[size] = (result[size] || 0) + 1;
      return result;
    }, {});

    return Object.entries(quantities).map(([size, quantity]) => ({
      id: variantForSize(size).id,
      quantity,
      properties: giftProperties(size, selectionToken)
    }));
  };

  const cartFromSections = sections => {
    const html = sections?.['mini-cart'] || '';
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const drawer = wrapper.querySelector('cart-drawer');
    return {
      sections,
      item_count: Number.parseInt(drawer?.dataset.itemCount || '0', 10) || 0,
      total_price: Number.parseInt(drawer?.dataset.totalPrice || '0', 10) || 0
    };
  };

  const publishCart = cart => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart }
    }));
  };

  const requestJson = async (url, body) => {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const json = await response.json();
    if (!response.ok) throw new Error(json.description || 'The free gifts could not be updated.');
    return json;
  };

  const promptEligibleQuantity = () => {
    const prompt = document.querySelector('[data-srg-cart-prompt]');
    return Math.max(0, Number.parseInt(prompt?.dataset.eligible || '0', 10) || 0);
  };

  const preferredGiftLine = () => {
    const lines = [...document.querySelectorAll('[data-srg-gift-line]')];
    return lines.find(line => line.dataset.srgRingSize === state.selectedSize) || lines.at(-1);
  };

  let pendingGiftQuantity = 0;
  let eligibleBeforeNativeAdd = null;
  let autoAddingGift = false;

  const flushAutomaticGift = async () => {
    if (autoAddingGift || pendingGiftQuantity < 1) return;

    const size = state.selectedSize || preferredGiftLine()?.dataset.srgRingSize || '';
    const variant = variantForSize(size);
    if (!variant) {
      pendingGiftQuantity = 0;
      return;
    }

    const quantity = pendingGiftQuantity;
    pendingGiftQuantity = 0;
    autoAddingGift = true;

    try {
      const existingLine = preferredGiftLine();
      let cart;

      if (existingLine && existingLine.dataset.srgRingSize === size) {
        cart = await requestJson(routes.change, {
          id: existingLine.dataset.srgLineKey,
          quantity: (Number.parseInt(existingLine.dataset.srgQuantity || '0', 10) || 0) + quantity,
          sections: ['mini-cart'],
          sections_url: window.location.pathname
        });
      } else {
        const selectionToken = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const result = await requestJson(routes.add, {
          items: [{
            id: variant.id,
            quantity,
            properties: giftProperties(size, selectionToken)
          }],
          sections: ['mini-cart'],
          sections_url: window.location.pathname
        });
        cart = cartFromSections(result.sections);
      }

      publishCart(cart);
    } catch (_) {
      // The customer can still choose or adjust gifts manually.
    } finally {
      autoAddingGift = false;
      if (pendingGiftQuantity > 0) flushAutomaticGift();
    }
  };

  const addChosenGifts = async () => {
    const modal = document.querySelector('[data-srg-modal]');
    if (!modal || state.submitting) return;

    const fieldsets = [...modal.querySelectorAll('fieldset')];
    const chosen = fieldsets.map(fieldset => fieldset.querySelector('input:checked')?.value).filter(Boolean);
    if (chosen.length !== fieldsets.length) {
      showModalError('Please choose a size for every ring.');
      return;
    }

    const selection = modal._srgSelection;
    const extraPaidSizes = selection.giftSizes.slice(selection.eligible);
    const desiredSizes = [...chosen, ...extraPaidSizes];
    if (sizesMatch(desiredSizes, selection.giftSizes)) {
      state.selectedSize = chosen[chosen.length - 1];
      localStorage.setItem('spongelle-ring-size', state.selectedSize);
      closeModal();
      return;
    }

    state.submitting = true;
    const button = modal.querySelector('[data-srg-modal-add]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Updating gifts…';
    }
    showModalError('');

    try {
      const selectionToken = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const items = groupedGiftItems(desiredSizes, selectionToken);
      let cart;

      if (selection.giftLines.length) {
        await requestJson(routes.add, { items });
        const updates = selection.giftLines.reduce((result, line) => {
          result[line.key] = 0;
          return result;
        }, {});
        cart = await requestJson(routes.update, {
          updates,
          sections: ['mini-cart'],
          sections_url: window.location.pathname
        });
      } else {
        const result = await requestJson(routes.add, {
          items,
          sections: ['mini-cart'],
          sections_url: window.location.pathname
        });
        cart = cartFromSections(result.sections);
      }

      state.selectedSize = chosen[chosen.length - 1];
      localStorage.setItem('spongelle-ring-size', state.selectedSize);
      closeModal();
      publishCart(cart);
    } catch (error) {
      showModalError(error.message || 'Something went wrong. Please try again.');
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = `Update free ${chosen.length === 1 ? 'ring' : 'rings'}`;
      }
    } finally {
      state.submitting = false;
    }
  };

  document.addEventListener('click', event => {
    const openButton = event.target.closest('[data-srg-open]');
    if (openButton) {
      event.preventDefault();
      openModal(openButton.closest('[data-srg-cart-prompt]'));
      return;
    }
    if (event.target.closest('[data-srg-close]')) {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.target.closest('[data-srg-modal-add]')) {
      event.preventDefault();
      addChosenGifts();
    }
  });

  document.addEventListener('variant:added', () => {
    if (eligibleBeforeNativeAdd === null) {
      eligibleBeforeNativeAdd = promptEligibleQuantity();
    }
  });

  document.addEventListener('line-item-quantity:change:end', event => {
    const eligibleLine = event.target.closest('[data-srg-eligible-line]');
    if (!eligibleLine) return;

    const previousQuantity = Number.parseInt(eligibleLine.dataset.srgQuantity || '0', 10) || 0;
    const nextQuantity = Number.parseInt(event.detail?.newLineQuantity || '0', 10) || 0;
    if (nextQuantity > previousQuantity) {
      pendingGiftQuantity += nextQuantity - previousQuantity;
    }
  });

  document.addEventListener('cart:render:end', () => {
    if (eligibleBeforeNativeAdd !== null) {
      pendingGiftQuantity += Math.max(0, promptEligibleQuantity() - eligibleBeforeNativeAdd);
      eligibleBeforeNativeAdd = null;
    }
    flushAutomaticGift();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installProductWidget, { once: true });
  } else {
    installProductWidget();
  }
})();
